import { Switch } from "antd";
import { ReactComponent as CheckIcon } from "../Assets/icons/check.svg";
import { ReactComponent as CloseSmallIcon } from "../Assets/icons/close_small.svg";
import spaIcon from "../Assets/icons/spa.png";
import NeedSlider from "./NeedSlider";

const Needs = ({
  categories = [],
  selectedValues,
  setSelectedValues,
  showMedecinDouce = true,
  alternativeMedicineEnabled,
  onMedecinDouceChange,
  translate,
  needsLevels = 5,
  labels = {},
  categoriesConfig = {},
}) => {
  const handleChange = (category, value) => {
    setSelectedValues((prev) => ({ ...prev, [category.value]: value }));
  };

  return (
    <div className="miltis-needs">
      <div className="miltis-needs__list">
        {categories.map((category) => (
          <NeedSlider
            key={category.value}
            category={category}
            value={selectedValues[category.value] || 1}
            onChange={(value) => handleChange(category, value)}
            translate={translate}
            needsLevels={needsLevels}
            labels={labels}
            categoriesConfig={categoriesConfig}
          />
        ))}
      </div>

      {showMedecinDouce && (
        <div className="miltis-needs__medecin-douce">
          <div className="miltis-needs__medecin-douce-info">
            <img
              src={spaIcon}
              alt="Médecine douce"
              className="miltis-needs__medecin-douce-icon"
            />
            <span className="miltis-needs__medecin-douce-title">
              {translate?.MEDECIN_DOUCE?.TITLE || "Médecine douce"}
            </span>
            <span className="miltis-needs__medecin-douce-description">
              <strong>Prise en charge</strong>{" "}
              {translate?.MEDECIN_DOUCE?.DESCRIPTION?.replace(
                "Prise en charge ",
                "",
              ) || "des dépenses en médecines naturelles"}
            </span>
          </div>
          <Switch
            checked={alternativeMedicineEnabled}
            onChange={onMedecinDouceChange}
            className="miltis-needs__medecin-douce-switch"
            checkedChildren={<CheckIcon />}
            unCheckedChildren={<CloseSmallIcon />}
          />
        </div>
      )}
    </div>
  );
};

export default Needs;
